const startMobileHub = () => { 
    const mobileHubBtn = document.querySelector('.c-mobile-hub__btn');

    if (!mobileHubBtn) {
        return;
    }

    const mobileHubContent = document.querySelector('.c-mobile-hub__content');
    const mobileHubMask = document.querySelector('.c-mobile-hub__mask');
    const mobileHubEllipsis = document.querySelector('.c-mobile-hub__ellipsis');
    const mobileHubSidebar = document.querySelector('.c-mobile-hub__sidebar');
    const mobileHubClose = document.querySelector('.c-mobile-hub__close');

    window.addEventListener('scroll', function(event) {
        let st = window.pageYOffset || document.documentElement.scrollTop || document.body.scrollTop || 0;

        if (st > 400) {
            mobileHubBtn.classList.add('is-visible');
        } else {
            mobileHubBtn.classList.remove('is-visible');
        }

        if (window.pageYOffset + window.innerHeight > document.documentElement.scrollHeight - 400) {
            mobileHubBtn.classList.remove('is-visible');
        }
    });

    addMobileHubButtonListener(mobileHubBtn, mobileHubMask, mobileHubEllipsis, mobileHubSidebar);
    addMobileHubCloseListener(mobileHubClose, mobileHubMask, mobileHubEllipsis, mobileHubSidebar);

    document.addEventListener('click', function(e) {
        if (e.target.matches('.c-jump-to__link')) {
            e.preventDefault();
            toggleMobileHubOff(mobileHubMask, mobileHubEllipsis, mobileHubSidebar);
            window.location = e.target.href;
        }
    });    

    document.addEventListener('mouseup', function(e) {
        if (document.body.classList.contains('c-mobile-hub--open')) {
            var menuClick = [mobileHubContent, mobileHubBtn, document.querySelector('.mfp-content')];

            if (!menuClick.some(function(element) { return element.contains(e.target); })) {
                mobileHubBtn.dispatchEvent(new Event('click'));
            }
        }
    });
}

const toggleMobileHub = (mobileHubMask, mobileHubEllipsis, mobileHubSidebar) => {
    document.body.classList.toggle('c-mobile-hub--open');
    mobileHubMask.classList.toggle('is-active');
    mobileHubEllipsis.classList.toggle('is-open');
    mobileHubSidebar.classList.toggle('is-open');
};

const toggleMobileHubOff = (mobileHubMask, mobileHubEllipsis, mobileHubSidebar) => {
    document.body.classList.remove('c-mobile-hub--open');
    mobileHubMask.classList.remove('is-active');
    mobileHubEllipsis.classList.remove('is-open');
    mobileHubSidebar.classList.remove('is-open');
};

const addMobileHubButtonListener = (mobileHubBtn, mobileHubMask, mobileHubEllipsis, mobileHubSidebar) => {
    mobileHubBtn.addEventListener('click', function(e) {
        e.preventDefault();
        toggleMobileHub(mobileHubMask, mobileHubEllipsis, mobileHubSidebar);
    });
}

const addMobileHubCloseListener = (mobileHubClose, mobileHubMask, mobileHubEllipsis, mobileHubSidebar) => {
    mobileHubClose.addEventListener('click', function(e) {
        e.preventDefault();
        toggleMobileHubOff(mobileHubMask, mobileHubEllipsis, mobileHubSidebar);
    });
}

startMobileHub();